// extracted by mini-css-extract-plugin
export default {"body":"InvalidUser_body__DmCLR","pillButtons":"InvalidUser_pillButtons__KlS99"};